import type {RefObject} from 'react';

import type {Timeout} from './types';

export function clearTimeouts(timeouts: RefObject<Timeout>[]): void {
    for (const timeout of timeouts) {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
    }
}
